var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.editType === 0 ? "新增角色" : "编辑角色",
            visible: _vm.drawer,
            direction: _vm.direction,
            modal: true,
            "destroy-on-close": false,
            wrapperClosable: false,
            size: "65%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _vm.drawer
            ? _c("div", { staticClass: "container v-height-flag" }, [
                _c(
                  "div",
                  { staticClass: "form-box" },
                  [
                    _c(
                      "el-form",
                      { attrs: { model: _vm.ruleForm, "label-width": "auto" } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "角色名称：", prop: "name" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入管理员名称",
                                size: "small",
                              },
                              model: {
                                value: _vm.ruleForm.role_name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "role_name", $$v)
                                },
                                expression: "ruleForm.role_name",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tabs",
                          {
                            staticClass: "mb20",
                            attrs: { type: "border-card" },
                            model: {
                              value: _vm.tabIndex,
                              callback: function ($$v) {
                                _vm.tabIndex = $$v
                              },
                              expression: "tabIndex",
                            },
                          },
                          [
                            _c("el-tab-pane", {
                              attrs: { label: "系统应用", name: "1" },
                            }),
                            _vm._v(" "),
                            _c("el-tab-pane", {
                              attrs: { label: "自定义应用", name: "2" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.tabIndex == 1
                          ? [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "管理范围：", prop: "name " },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { placeholder: "请选择" },
                                          on: { change: _vm.dataLevelFn },
                                          model: {
                                            value: _vm.ruleForm.data_level,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "data_level",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.data_level",
                                          },
                                        },
                                        _vm._l(_vm.options, function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.ruleForm.data_level == "3"
                                        ? _c("select-department", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              value: _vm.activeMastart || [],
                                              placeholder: "请选择",
                                            },
                                            on: {
                                              changeMastart: function ($event) {
                                                return _vm.changeMastart(
                                                  $event,
                                                  "",
                                                  ""
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tabIndex == 1,
                        expression: "tabIndex == 1",
                      },
                    ],
                    staticClass: "roles-box",
                  },
                  [
                    _c("rolesTree", {
                      ref: "rolesTree",
                      attrs: {
                        "tree-data": _vm.treeData,
                        "default-checked-keys": _vm.defaultCheckedKeys,
                        "roles-list": _vm.rolesList,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tabIndex == 2,
                        expression: "tabIndex == 2",
                      },
                    ],
                    staticClass: "table-box",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "mb14 flex" },
                      [
                        _c("el-input", {
                          staticClass: "mr10",
                          staticStyle: { width: "250px" },
                          attrs: {
                            placeholder: "请输入实体名称",
                            size: "small",
                            "prefix-icon": "el-icon-search",
                          },
                          model: {
                            value: _vm.searchKey,
                            callback: function ($$v) {
                              _vm.searchKey = $$v
                            },
                            expression: "searchKey",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "250px" },
                            attrs: {
                              placeholder: "请选择关联应用(多选)",
                              size: "small",
                              filterable: "",
                              multiple: "",
                              "collapse-tags": "",
                            },
                            model: {
                              value: _vm.cate_id,
                              callback: function ($$v) {
                                _vm.cate_id = $$v
                              },
                              expression: "cate_id",
                            },
                          },
                          _vm._l(_vm.application, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading",
                          },
                        ],
                        key: _vm.itemKey,
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.searchList },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "table_name",
                            label: "实体名称",
                            "min-width": "120",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "查看权限", width: "300" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "flex" },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              size: "small",
                                              placeholder: "请选择",
                                            },
                                            model: {
                                              value: scope.row.reade,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "reade",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.reade",
                                            },
                                          },
                                          _vm._l(_vm.crudList, function (item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                              },
                                            })
                                          }),
                                          1
                                        ),
                                        _vm._v(" "),
                                        scope.row.reade == 3
                                          ? _c("select-department", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                value:
                                                  scope.row.reade_frames || [],
                                                placeholder: "请选择",
                                                "is-search": true,
                                              },
                                              on: {
                                                changeMastart: function (
                                                  $event
                                                ) {
                                                  return _vm.changeMastart(
                                                    $event,
                                                    "reade_frame",
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1868842026
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "新增权限", width: "110" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          size: "small",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: scope.row.created,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "created", $$v)
                                          },
                                          expression: "scope.row.created",
                                        },
                                      },
                                      _vm._l(_vm.allowOptions, function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2445129193
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "date",
                            label: "修改权限",
                            width: "280",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "flex" },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              size: "small",
                                              placeholder: "请选择",
                                            },
                                            model: {
                                              value: scope.row.updated,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "updated",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.updated",
                                            },
                                          },
                                          _vm._l(_vm.crudList, function (item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                              },
                                            })
                                          }),
                                          1
                                        ),
                                        _vm._v(" "),
                                        scope.row.updated == 3
                                          ? _c("select-department", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                value:
                                                  scope.row.updated_frames ||
                                                  [],
                                                placeholder: "请选择",
                                                "is-search": true,
                                              },
                                              on: {
                                                changeMastart: function (
                                                  $event
                                                ) {
                                                  return _vm.changeMastart(
                                                    $event,
                                                    "updated_frame",
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3536322730
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "date",
                            label: "删除权限",
                            "min-width": "280",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "flex" },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              size: "small",
                                              placeholder: "请选择",
                                            },
                                            model: {
                                              value: scope.row.deleted,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "deleted",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.deleted",
                                            },
                                          },
                                          _vm._l(_vm.crudList, function (item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                              },
                                            })
                                          }),
                                          1
                                        ),
                                        _vm._v(" "),
                                        scope.row.deleted == 3
                                          ? _c("select-department", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                value:
                                                  scope.row.deleted_frames ||
                                                  [],
                                                placeholder: "请选择",
                                                "is-search": true,
                                              },
                                              on: {
                                                changeMastart: function (
                                                  $event
                                                ) {
                                                  return _vm.changeMastart(
                                                    $event,
                                                    "deleted_frames",
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2633661945
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "from-foot-btn fix btn-shadow" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.close } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.loading,
                  },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("public.save")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }